import { BaseController } from './BaseController'
import envConfig from '../../envConfig'

export class ConfigController extends BaseController {
  async getAtlasConfig (): Promise<any> {
    const baseUrl = envConfig.stage === 'prod' ? 'https://get.atlas-config.mit.edu' : envConfig.stage === 'test' ? 'https://get.atlas-config-test.mit.edu' : 'https://get.atlas-config-dev.mit.edu'
    const response = await this.useFetchWithoutHeaders('GET', 'profile', `${baseUrl}/?key=${envConfig.appName}${envConfig.appNameSuffix}`)

    if (response.status === 200) {
      const data = response.json()
      return data
    } else {
      const text = await response.text()
      return await Promise.reject(text)
    }
  }
}
